<template>
  <div>
    <v-container class="pt-3 pb-6 px-6">

      <!-- Download Excel -->
      <floating-button download v-if="authUser">
        <v-btn fab class="white--text" color="deep-orange" @click="exportExcel()">
          <v-icon>mdi-file-excel</v-icon>
        </v-btn>
      </floating-button>

      <!-- Page Header -->
      <page-header
        title="Materiales Consumidos"
        icon="mdi-view-list"
        divider="-"
        :breadcrumbs="breadcrumbs.items"
        refresh
        @refresh="init(true)"
      ></page-header>

      <!-- Content -->
      <v-row align="center" justify="center">
        <!-- Table -->
        <v-col cols="12">
          <!-- Loading Bar -->
          <v-progress-linear
            indeterminate
            v-if="isLoadingData"
          ></v-progress-linear>
          <!-- Table -->
          <v-data-table
            v-show="authUser"
            class="elevation-1"
            :headers="headers"
            :items="items"
            :options.sync="pagination"
            :server-items-length="pagination_total"
            :footer-props="{
              'items-per-page-options': [5, 50, 100, 250, 500]
            }"
            @update:options="init()"
          >
            <!-- Top -->
            <template v-slot:top>
              <v-toolbar flat color="white">
                <!-- Material Filter -->
                <v-select
                  label="Tipo de material"
                  v-model="filters.material_type_id"
                  :items="materialTypes"
                  item-text="name"
                  item-value="id"
                  class="shrink mr-5"
                  clearable
                  hide-details
                  single-line
                  @change="init()"
                ></v-select>
                <!-- Farm Filter -->
                <v-select
                  label="Parque"
                  v-model="filters.wind_farm_id"
                  :items="farms"
                  item-text="name"
                  item-value="id"
                  class="shrink mr-5"
                  clearable
                  hide-details
                  single-line
                  @change="init()"
                ></v-select>
                <!-- User Filter -->
                <v-select
                  label="Operario"
                  v-model="filters.user_name"
                  :items="technicians"
                  :item-text="text"
                  item-value="id"
                  class="shrink mr-5"
                  clearable
                  hide-details
                  single-line
                  @change="init()"
                ></v-select>
                <!-- From Filter -->
                <v-menu
                  v-model="menu.from"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      label="Fecha Desde"
                      :value="formatDate(filters.date_from)"
                      class="mr-5"
                      readonly
                      clearable
                      hide-details
                      v-on="on"
                      @click:clear="filters.date_from = '', init()"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="filters.date_from" @change="menu.from = false, init()"></v-date-picker>
                </v-menu>
                <!-- To Filter -->
                <v-menu
                  v-model="menu.to"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      label="Fecha Hasta"
                      :value="formatDate(filters.date_to)"
                      readonly
                      clearable
                      hide-details
                      v-on="on"
                      @click:clear="filters.date_to = '', init()"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="filters.date_to" @change="menu.to = false, init()"></v-date-picker>
                </v-menu>
              </v-toolbar>
            </template>
            <!-- Date -->
            <template v-slot:item.date="{ item }">
              {{ formatDate(item.date) }}
            </template>
            <!-- Operators -->
            <template v-slot:item.users="{ item }">
              <span v-if="item.users">
                <div v-for="item in item.users" :key="item.id" >
                  <v-chip class="ma-1" light>{{ item }}</v-chip>
                </div>
              </span>
            </template>
            <!-- No Data -->
            <template v-slot:no-data>
              No hay elementos
            </template>
            <!-- No Results -->
            <template v-slot:no-results>
              No hay elementos
            </template>
          </v-data-table>
        </v-col>
      </v-row>

    </v-container>
  </div>
</template>

<script>
import FloatingButton from "@/components/FloatingButton";
import PageHeader from "@/components/PageHeader";
import Util from "@/util/index";
import moment from 'moment'
import XLSX from 'xlsx'

export default {
  components: {
    FloatingButton,
    PageHeader
  },
  data: () => ({
    authUser: false,
    loadFilters: true,
    isLoadingData: false,
    menu: {
      from: false,
      to: false
    },
    filters: {
      material_type_id: '',
      wind_farm_id: '',
      user_name: '',
      date_from: '',
      date_to: ''
    },
    pagination: {
      page: 1,
      itemsPerPage: 5,
      sortBy: [],
      sortDesc: []
    },
    pagination_total: -1,
    breadcrumbs: {
      items: [
        { text: "Otros Informes", disabled: true },
        { text: "Materiales Consumidos", disabled: true }
      ]
    },
    headers: [
      { text: "Material", value: "material_type_name", align: "left", sortable: true },
      { text: "Cantidad", value: "quantity", align: "center", sortable: false },
      { text: "Fecha", value: "date", align: "center", sortable: true },
      { text: "Parque", value: "wind_farm_name", align: "center", sortable: true },
      { text: "Operarios", value: "users", align: "center", sortable: false },
    ],
  }),
  computed: {
    items () {
      return this.$store.state.other_reports.materials_used
    },
    materialTypes () {
      return this.$store.state.interventions.options.materialTypes
    },
    farms () {
      return this.$store.state.farms.wind_farms.filter(element => element.is_active === true)
    },
    technicians () {
      return this.$store.state.users.all.filter(element => {
        return element.roles.filter(e => e.name === 'Operario').length > 0 && element.isActive === true
      })
    },
  },
  methods: {
    formatDate(date) {
      return Util.formatDate(date)
    },
    text (item) {
      return item.lastName2
        ? item.firstName + ' ' + item.lastName1 + ' ' + item.lastName2
        : item.firstName + ' ' + item.lastName1
    },
    exportExcel() {
      const data = []
      const obj = {}

      for (let i=0; i < this.headers.length; i++) {
        const element = this.headers[i]
        obj[element.value] = element.text
      }

      data.push(obj)

      for (let i=0; i < this.items.length; i++) {
        const element = this.items[i]
        const obj = {
          ...element
        }
        obj.date = this.formatDate(element.date)
        obj.users = element.raw_users
        delete obj.raw_users
        data.push(obj)
      }

      const name = 'materiales_utilizados_' + moment().format('DD_MM_YYYY') + '.xlsx'
      
      /* make the worksheet */
      const ws = XLSX.utils.json_to_sheet(data, { skipHeader: true })

      /* add to workbook */
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, '');

      /* generate an XLSX file */
      XLSX.writeFile(wb, name)
    },
    init (loadFilters) {
      this.isLoadingData = true;
      const body = {
        page: this.pagination.page,
        perPage: this.pagination.itemsPerPage,
        filters: this.filters
      }
      // Sort
      if (this.pagination.sortDesc.length) body.sortType = this.pagination.sortDesc[0] ? 'desc' : 'asc'
      if (this.pagination.sortBy.length) {
        const sortBy = this.pagination.sortBy[0]
        body.sortBy = sortBy
      }
      this.$store.dispatch('other_reports/materialsUsed', body)
        .then(res => {
          this.authUser = true
          const meta = res.data.meta
          this.pagination_total = meta.total
        })
        .catch(error => {
          if (error.response.status === 403 ) {
            this.$toast("Su perfil de usuario no tiene los permisos suficientes para acceder a esta funcionalidad del sistema.", {
              color: "error",
              x: "center",
              y: "top",
              icon: "mdi-information",
              timeout: 0,
              showClose: true,
              closeText: "Cerrar"
            });
            this.$router.push({ name: 'home'})
          } else {
            var errorToastMessage = "Ha ocurrido un error cargando los datos."
            Util.showErrorToast(this, error, errorToastMessage);
          }
        })
        .finally(() => {
          if (this.loadFilters || loadFilters) this.loadUsers()
          else if (!this.loadFilters) this.isLoadingData = false
          this.loadFilters = false
        })
    },
    loadUsers() {
      this.$store.dispatch("users/getAllUsers")
        .catch(error => {
          if (error.response.status === 403 ) {
            this.$toast("Su perfil de usuario no tiene los permisos suficientes para acceder a esta funcionalidad del sistema.", {
              color: "error",
              x: "center",
              y: "top",
              icon: "mdi-information",
              timeout: 0,
              showClose: true,
              closeText: "Cerrar"
            });
            this.$router.push({ name: 'home'})
          } else {
            var errorToastMessage = "Ha ocurrido un error cargando la lista de operarios."
            Util.showErrorToast(this, error, errorToastMessage);
          }
        })
        .finally(() => {
          this.loadFarms()
        });
    },
    loadFarms () {
      this.$store.dispatch('farms/getFarms')
        .catch(error => {
          if (error.response.status === 403 ) {
            this.$toast("Su perfil de usuario no tiene los permisos suficientes para acceder a esta funcionalidad del sistema.", {
              color: "error",
              x: "center",
              y: "top",
              icon: "mdi-information",
              timeout: 0,
              showClose: true,
              closeText: "Cerrar"
            });
            this.$router.push({ name: 'home'})
          } else {
            var errorToastMessage = "Ha ocurrido un error cargando la lista parques eólicos."
            Util.showErrorToast(this, error, errorToastMessage);
          }
        })
        .finally(() => {
          this.loadMaterials()
        });
    },
    loadMaterials () {
      this.$store.dispatch('interventions/options/getMaterialTypes')
        .catch(error => {
          if (error.response.status === 403 ) {
            this.$toast("Su perfil de usuario no tiene los permisos suficientes para acceder a esta funcionalidad del sistema.", {
              color: "error",
              x: "center",
              y: "top",
              icon: "mdi-information",
              timeout: 0,
              showClose: true,
              closeText: "Cerrar"
            });
            this.$router.push({ name: 'home'})
          } else {
            var errorToastMessage = "Ha ocurrido un error cargando la lista de materiales."
            Util.showErrorToast(this, error, errorToastMessage);
          }
        })
        .finally(() => {
          this.isLoadingData = false
        });
    },
  }
}
</script>
